/**
 *@TODO add detection for MS EDGE
 *		add detection for cocoon wrapper
 */
(function(ehdi){
	'use strict';
	ehdi.BrowserInfo = Object.create(null);
	
	var navigator = window.navigator;
	var info = ehdi.BrowserInfo;
	var userAgent = navigator.userAgent;
	var regex, ver;

	var getiPhoneVersion = function(){
		var iHeight = window.screen.height;
		var iWidth = window.screen.width;
		if (iWidth === 320 && iHeight === 480) {
			return "4";
		}
		else if (iWidth === 375 && iHeight === 667) {
			return "6";
		}
		else if (iWidth === 414 && iHeight === 736) {
			return "6+";
		}
		else if (iWidth === 320 && iHeight === 568) {
			return "5";
		}
		else if (iHeight <= 480) {
			return "1-3";
		}
		return ' ';
	}
	
	info.platformType = navigator.platform;
	info.platformVersion = "";
	info.browserName = navigator.appName;
	info.browserVersion = navigator.appVersion;
	info.isMobileDevice = false;
	info.isIOS = false;
	info.deviceType = "desktop";
	
	//Platform
	if(navigator.platform.indexOf('iPhone') !== -1){
		info.isMobileDevice = true;
		info.platformType = "iPhone " + getiPhoneVersion();
		info.deviceType = "phone";
		info.isIOS = true;
		regex = /OS (\d+_\d+)/g;
		if(userAgent.search(regex) !== -1){
			ver = String(userAgent.match(regex));
			info.platformVersion = ver.replace("_",".");
		}
	}else if(navigator.platform.indexOf('iPod') != -1){
		info.isMobileDevice = true;
		info.platformType = "iPod";
		info.deviceType = "tablet";
		info.isIOS = true;
		regex = /OS (\d+_\d+)/g;
		if(userAgent.search(regex) !== -1){
			ver = String(userAgent.match(regex));
			info.platformVersion = ver.replace("_",".");
		}
	}else if(navigator.platform.indexOf('iPad') != -1){
		info.isMobileDevice = true;
		info.platformType = "iPad";
		info.deviceType = "tablet";
		info.isIOS = true;
		regex = /OS (\d+_\d+)/g;
		if(userAgent.search(regex) !== -1){
			ver = String(userAgent.match(regex));
			info.platformVersion = ver.replace("_",".");
		}
	}else if(userAgent.indexOf('Android') != -1){
		info.isMobileDevice = true;
		info.platformType = "Android";
		info.deviceType = "tablet";
		regex = /OS (\d+_\d+)/g;
		if(userAgent.search(regex) !== -1){
			ver = String(userAgent.match(regex));
			info.platformVersion = ver.replace("_",".");
		}
	}else if(userAgent.indexOf('Kindle') != -1 || userAgent.indexOf('Silk') != -1){
		info.isMobileDevice = true;
		info.platformType = "Android";
		info.deviceType = "tablet";
	}else if(userAgent.indexOf('IEMobile') != -1){
		info.isMobileDevice = true;
		info.platformType = "IEMobile";
		info.deviceType = "phone";
		regex  = /IEMobile\/(\d+\.\d+)/g;
		if(userAgent.search(regex) !== -1) info.platformVersion = String(userAgent.match(regex));
	}else if(navigator.platform.indexOf('Win') != -1){
		info.platformType = 'Windows';
		info.deviceType = "desktop";
	}else if(navigator.platform.indexOf('Mac') != -1){
		info.platformType = 'MAC';
		info.deviceType = "desktop";
		regex = /OS (\d+_\d+)/g;
		if(userAgent.search(regex) !== -1){
			ver = String(userAgent.match(regex));
			info.platformVersion = ver.replace("_",".");
		}
	}else if(navigator.platform.indexOf('Linux') != -1){
		info.platformType = 'Linux';
		info.deviceType = "desktop";
	}
	
	var _browser = (function(){
		var ua= navigator.userAgent, tem,
		M= ua.match(/(crios|samsungbrowser|opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
		if(/trident/i.test(M[1])){
			tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
			return 'IE '+(tem[1] || '');
		}
		if(M[1]=== 'Chrome'){
			tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
			if(tem != null){
				if(tem.indexOf('OPR') != -1) return tem.slice(1).join(' ').replace('OPR', 'Opera');
				if(tem.indexOf('Edge') != -1) return tem.slice(1).join(' ').replace('Edge', 'Edge');				
			}
		}
		M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
		if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
		return M.join(' ');
	})();
	
	info.browserName = _browser.split(" ")[0];
	if(info.browserName.toUpperCase() === "CRIOS") info.browserName = "Chrome";
	info.browserVersion = _browser.split(" ")[1]; 
	
	ehdi.checkGLQuality = function(renderer){
		if(!renderer) throw new Error("pass renderer as parameters");
		var max = 0;
		var gl = renderer.view.getContext("webgl") || renderer.view.getContext("experimental-webgl");
		
		if(!gl) return "canvas";
		
		var ext = (
			gl.getExtension('EXT_texture_filter_anisotropic') ||
			gl.getExtension('MOZ_EXT_texture_filter_anisotropic') ||
			gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic')
		)
		if(ext) max = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
		
		if(max > 4) return "gl-high"
		
		return "gl-normal";
	}
	
	return ehdi;
}(EHDI || Object.create(null)))
